import {useTranslation} from "../../../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import React, {useCallback, useMemo} from "react";
import {getRandomString, stringify} from "../../../common/generic-react.functions.js";
import {useDataTableParsers} from "./data-table.hooks.js";
import {DataTableBodyContainer, DataTableContainer, DataTableContentContainer, DataTableHeaderContainer, DataTableThContainer, DateTableTdContainer} from "./data-table.styles.js";
function DataTable({
  headers,
  items,
  options,
  columns,
  onPaginate
}) {
  const {
    t
  } = useTranslation();
  const {
    headerInfo: [headerInfo],
    parsedItems: [parsedItems],
    sortInfo,
    sortColumn,
    paginationElement
  } = useDataTableParsers({
    headers,
    items,
    options,
    onPaginate
  });
  const generateHeader = useCallback(({
    text,
    align,
    value,
    width
  }) => {
    const [sortText, sortIcon, sortCls] = sortInfo(value);
    const onClick = sortIcon ? () => sortColumn(value) : void 0;
    return /* @__PURE__ */ React.createElement(DataTableThContainer, {
      key: `header__${value.toString()}`,
      className: `data-table__header${sortCls}`,
      role: "columnheader",
      scope: "col",
      "aria-label": typeof text === "string" ? text : void 0,
      "aria-sort": sortText,
      textAlign: align,
      onClick,
      clickable: !!onClick,
      width
    }, /* @__PURE__ */ React.createElement("span", {
      className: "data-table__header--text"
    }, text), " ", sortIcon);
  }, [sortColumn, sortInfo]);
  const generateItem = useCallback((item) => {
    return /* @__PURE__ */ React.createElement("tr", {
      key: `content__tr__${stringify(item) || getRandomString()}`
    }, Object.keys(headerInfo).map((value) => {
      const it = value in item ? item[value.toString()] : null;
      const content = columns && value in columns ? columns[value.toString()] : it;
      return /* @__PURE__ */ React.createElement(DateTableTdContainer, {
        key: `content__td__${value}__${getRandomString()}`,
        className: "data-table__header",
        textAlign: headerInfo[value.toString()].align,
        width: headerInfo[value.toString()].width
      }, typeof content === "function" ? content(item) : content);
    }));
  }, [columns, headerInfo]);
  const tableItems = useMemo(() => {
    const emptyItemsText = options?.empty || t("common.emptyTable");
    const emptyItems = /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", {
      colSpan: headers.length
    }, emptyItemsText));
    return parsedItems && parsedItems.length ? parsedItems.map(generateItem) : emptyItems;
  }, [generateItem, headers.length, options?.empty, parsedItems, t]);
  return /* @__PURE__ */ React.createElement(DataTableContainer, null, /* @__PURE__ */ React.createElement(DataTableContentContainer, null, /* @__PURE__ */ React.createElement(DataTableHeaderContainer, null, /* @__PURE__ */ React.createElement("tr", null, headers.map(generateHeader))), /* @__PURE__ */ React.createElement(DataTableBodyContainer, null, tableItems)), paginationElement);
}
export default /* @__PURE__ */ React.memo(DataTable);
